import type { VoidFunctionComponent } from 'react';

import { isFreeTier } from '../../../../shared/subscriptions';
import { window } from '../../../globals';
import { Menu, MenuItem } from '../../generic';
import Button from '../../generic/Button';
import PaidFeatureGate from '../../generic/Gates/PaidFeatureGate';
import { icons } from '../../generic/Icon';
import type { LicensingRuleType } from '../../../../shared/model-typings';
import type { LicensingRule } from '../../../types';
import type { LicenseIdOnly } from '../LicensePolicyRevamp/DisplayLicensePolicyPageV2';

import styles from './Rules.module.less';

type ActionDropdownProps = {
  ruleType?: LicensingRuleType;
  selectedLicenses: Set<string>;
  uncategorizedLicenses?: LicenseIdOnly[];
  rulesInList: LicensingRule[];
  isDefault: boolean;
  isDeleteEnabled?: boolean;
  setSelectedLicenses: (selectedLicenses: Set<string>) => void;
  onRuleAdd?(defaultRule?: LicensingRule): void;
  onSetAsDefault?(): void;
  onBulkAction?(): void;
  selectAllLicenses(): void;
  onBulkDelete(): void;
};

export const ActionDropdown: VoidFunctionComponent<ActionDropdownProps> = (props) => {
  const isCustomizationRestricted = isFreeTier({
    plan: window.user?.organization?.stripe_plan,
    stripePriceLimit: window.user?.organization?.stripePriceLimit,
  });

  return (
    <div className={styles.actionsButton}>
      <Menu
        key="buttonGroup"
        title="Actions"
        id={`rule-list-action-dropdown-${props.ruleType || 'uncategorized'}`}
        menuButton={<Button type="text" icon={icons.ellipsisHorizontal} size="large" onClick={() => {}} />}
        direction="left"
      >
        {props.ruleType && (
          <>
            <PaidFeatureGate hidePill isRestricted={isCustomizationRestricted}>
              <MenuItem onClick={props.onSetAsDefault} disabled={!props.ruleType || props.isDefault}>
                Make this the default category
              </MenuItem>
            </PaidFeatureGate>
            <MenuItem onClick={() => props.onRuleAdd?.()} disabled={!props.ruleType || props.selectedLicenses.size > 0}>
              Create new rule
            </MenuItem>
            <hr className={styles.actionsBar} />
          </>
        )}
        <span className={styles.actionsCategory}>LICENSE ACTIONS</span>
        <MenuItem
          onClick={() => props.selectAllLicenses()}
          disabled={
            (props.ruleType && props.selectedLicenses.size >= props.rulesInList.length) ||
            (!props.ruleType &&
              props.uncategorizedLicenses &&
              props.selectedLicenses.size >= props.uncategorizedLicenses.length)
          }
        >
          Select All
        </MenuItem>
        <MenuItem onClick={() => props.setSelectedLicenses(new Set())} disabled={props.selectedLicenses.size === 0}>
          Deselect All
        </MenuItem>
        <MenuItem onClick={props.onBulkAction} disabled={props.selectedLicenses.size === 0}>
          {props.ruleType ? 'Edit selected' : 'Move selected'}
        </MenuItem>
        {props.isDeleteEnabled && (
          <MenuItem onClick={() => props.onBulkDelete()} disabled={props.selectedLicenses.size === 0}>
            Delete selected
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};
